import styled from "styled-components"

export const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const InputStyled = styled.input`
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  box-sizing: border-box;
  margin: 0;
  line-height: inherit;
  background: none;
  overflow: visible;
  width: 100%;
  border-radius: 4px;
  padding: 0 20px;
  height: 44px;
  background-color: rgba(246, 246, 246, 0.3);
  border: 2px solid #d8dde6;
  font-size: 14px;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  color: white;
  font-family: "Montserrat", Helvetica, sans-serif;

  /* Each state carries only what it actually changes. The :active, :focus-within
     and :focus-visible blocks that used to be here restated the base
     declaration verbatim, so they changed nothing. */
  :hover {
    border-color: #a3afc4;
  }

  :focus {
    background-color: rgba(246, 246, 246, 0.2);
    border-color: #dff0ff;
    outline: none;
  }

  /* Keyboard focus needs an indicator the border-colour shift is too faint to
     provide. Mouse and touch focus keep the original look. */
  :focus-visible {
    outline: 2px solid #ee0081;
    outline-offset: 2px;
  }
`

export const LabelStyled = styled.label`
  font-family: "Alliance No.1";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 15px;
  color: #86a2b6;
  margin-bottom: 6px;
`

export const InfoStyled = styled.span`
  color: #32de84;
  margin-top: 4px;
  font-size: 16px;
  height: 0px;
`
